module.exports = __webpack_public_path__ + "img/LandschaftV.760327d7.jpg";